import React, { useEffect } from "react";

//imagenes
import logo_azul from "../../assets/images/logo_azul.png";
import logo from "../../assets/images/logo.png";

//iconos
import menu from "../../assets/icons/menu.svg";
import menu_azul from "../../assets/icons/menu_azul.svg";

const EncabezadoComponent = (props) => {
  useEffect(() => {}, []);

  return (
    <div
      className={"header alto " + (props.inicio ? "box" : "")}
      style={
        props.activate
          ? {
              position: "fixed",
              padding: "0 30px",
              backgroundColor: "rgba(252, 250, 250, 0.8)",
            }
          : null
      }
    >
      <div className="logo_menu">
        {/* {props.negocios ? (
          <img src={menu} />
        ) : props.activate ? (
          <img src={menu_azul} />
        ) : null} */}
        <div className="descripcion_menu">
          {/* <p
            className={
              props.inicio
                ? "desc-inicio"
                : props.negocios
                ? "desc-negocios"
                : ""
            }
          >
            <a href={props.path}>{props.desc1}</a> / <b>{props.desc2}</b>
          </p> */}
        </div>
      </div>
      {props.inicio ? <span></span> : null}
      <div className={props.inicio ? "inicio" : "logo_principal"}>
        <img
          src={props.inicio ? logo_azul : props.negocios ? logo : logo_azul}
        />
      </div>
    </div>
  );
};

export default EncabezadoComponent;
